import currencies from 'src/components/Common/Inputs/currencies.json'

export default (value, args) => {
  if (value === undefined || value === null) {
    return false
  }

  return currencies.map(currency => currency.value).includes(value)
}
